export const defaultValueForm = {
  name: '',
  email: '',
  password: '',
  role: null,
  brand: [],
  ecommerces: [],
  nik: '',
  handphone: '',
  address: '',
  gender: '',
  domicile: '',
  isLdap: false,
  baId: '',
  nip: '',
  joinDate: '',
  terminateDate: '',
};

export const optionsGender = [
  {
    label: 'Laki-laki',
    value: 'MALE',
  },
  {
    label: 'Perempuan',
    value: 'FEMALE',
  },
];
